import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  error = '';
  loading = true;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    void this.initialize();
  }

  async initialize(): Promise<void> {
    try {
      const user = await this.authService.initializeSession().catch(() => null);
      if (user) {
        await this.router.navigate(['/dashboard'], { replaceUrl: true });
        return;
      }
      await this.signIn();
    } catch {
      this.error = 'Unable to sign in. Please try again.';
      this.loading = false;
    }
  }

  async signIn(): Promise<void> {
    this.error = '';
    this.loading = true;
    try {
      await this.authService.signIn();
    } catch {
      this.error = 'Unable to sign in. Please try again.';
      this.loading = false;
    }
  }
}
